module.exports = __webpack_public_path__ + "static/media/cellfinate_fondo_bolitas.d10210b1.jpg";